import { PANEL, MAP_TOOL } from '@tmapy/config';
import { SET_PANEL, SET_MAP_TOOL, SET_UI_MANAGER_STATE } from './constants';
const initialState = {
    visiblePanel: PANEL.NONE,
    activeMapTool: MAP_TOOL.NONE,
    defaultMapTool: MAP_TOOL.NONE,
};
export const uiManager = (state = initialState, action) => {
    switch (action.type) {
        case SET_UI_MANAGER_STATE: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case SET_PANEL: {
            const visiblePanel = action.payload;
            return {
                ...state,
                visiblePanel,
            };
        }
        case SET_MAP_TOOL: {
            const activeMapTool = action.payload;
            return {
                ...state,
                activeMapTool,
            };
        }
        default: {
            return state;
        }
    }
};
//# sourceMappingURL=reducer.js.map